import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-products-dashboard',
  templateUrl: './products-dashboard.component.html',
  styleUrls: ['./products-dashboard.component.scss']
})
export class ProductsDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
